import styled from "styled-components";

export const StyledAdditionalDataDiv = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.space.xs} 0;
  line-height: ${({ theme }) => theme.line.height.base};
`;

export const StyledSpanAdditionalDataText = styled.span`
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`;

export const StyledSpanAdditionalDataValue = styled.span`
  color: ${({ theme }) => theme.colors.gray700};
  padding-left: ${({ theme }) => theme.space.xs};
  ${(props) =>
    !props.isViewAllClicked &&
    `text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      @media (--bp-sm), print {
        text-overflow: clip;
        overflow: visible;
        white-space: normal;
      }
    `};
`;

export const StyledViewAllLink = styled.div`
  min-width: 3.5rem;
  padding-left: 0.125rem;
  @media print {
    display: none;
  }
`;
